import { NavBar } from '../components';
import {
  Outlet
} from "react-router-dom";
import { useState } from 'react';
import {
  Navigate,
  useLocation
} from "react-router-dom";

export default function App() {
  const [open, setOpen] = useState(false);
  const myLocation = useLocation();

  if (
    !["/home", "/broadside", "/app", "/impact", "/missions"].includes(
      myLocation.pathname
    )
  ) {
    return <Navigate to="/home" />;
  }

  const pagesWithCoverArt = ['/missions'];
  const transparentHeader = pagesWithCoverArt.includes(myLocation.pathname);

  return (
    <>
      <Outlet />
      <div>
        <NavBar navOpen={open} setNavOpen={setOpen} isTransparent={transparentHeader} />
        {/*<FloatingSubscribe />*/}
      </div>
    </>
  );
}
